<template lang="pug">
.container-cta.dark-cta
  .container-fluid
    .row
      .col-lg-12.text-center
        h2 Why not share this page with your friends?
        a(:href="getUrl('f')" target="_blank")
          i.fab.fa-facebook-square(style="color: #4267B2")
        a(:href="getUrl('t')" target="_blank")
          i.fab.fa-twitter-square(style="color: #1DA1F2")
        //- a(:href="getUrl('l')" target="_blank")
          i.fab.fa-linkedin(style="color: #2867B2")
        a(:href="getUrl('w')" target="_blank")
          i.fab.fa-whatsapp(style="color: #4AC959")
</template>

<script>
export default {
  props: ['backendHost', 'frontendHost', 'page'],
  methods: {
    getUrl(type) {
      const url = encodeURIComponent(`${this.frontendHost}${this.page}`)

      return `${this.backendHost}/magic/${type}?page=${url}`
    }
  }
}
</script>

<style lang="scss" scoped>
  i {
    font-size: 60px;
    margin: 0 10px;
  }
</style>
